/****************************************************************
 * CODE collectionBanner
 ****************************************************************/

!(function ($, document, window, undefined) {
  /**
   * Plugin name
   */
  var _pluginName = "collectionBanner";

  /**
   * @param jQuery Element itself
   * @return collectionBanner_plugin
   */
  var collectionBanner_plugin = function ($element, options) {
    if ($.code.debug) {
      console.log("Init collectionBanner");
    }
    console.log($.code.debug);
    // scope it
    var self = this;
    self.$element = $element;
    self.bannerUrl = $element.data("collection-banner-url");

    // Fetch the actual banner to go in this place
    $.get(self.bannerUrl, function (data) {
      var counter = 1;

      $(data)
        .find("[data-collection-banner-product]")
        .each(function (index) {
          var $newElem = $(this);
          var newElemPosition = $newElem.data("banner-position");
          var newElemPositions = newElemPosition.toString().split(",");

          // Count the position and insert it at the correct place
          $.each(newElemPositions, function (i, value) {
            var ProductBlockLength = $("[data-product-block]").length;

            if (value <= ProductBlockLength) {
              $element
                .find("[data-product-block]:eq(" + (value - counter) + ")")
                .before($newElem.clone());
            } else {
              $element
                .find("[data-product-block]:last-child")
                .after($newElem.clone());
            }
            counter++;
          });
        });
    });
  };

  /**
   * collectionBanner plugin
   *
   * @return jQuery objects
   */
  $.fn.collectionBanner = function (options) {
    // put args in array
    var args = Array.prototype.slice.call(arguments, 1);

    // initialize the items
    return this.each(function () {
      // store the element the plugin is set on
      var $element = $(this);

      // guard if plugin was already initted
      var instance = $element.data("plugin_" + _pluginName);

      // if plugin was not innited
      if (!instance) {
        // init plugin on element and set guard data on element
        $element.data(
          "plugin_" + _pluginName,
          new collectionBanner_plugin($element, options)
        );
      }
    });
  };
})(jQuery, document, window);

/****************************************************************
 * CODE Country Popup
 ****************************************************************/

!(function ($, document, window, undefined) {
  /**
   * Plugin name
   */
  var _pluginName = "countryPopup";

  /**
   * @param jQuery Element Wrapping container div
   * @return countryPopup_plugin
   */
  var countryPopup_plugin = function ($element, options) {
    // scope
    var self = this;
    self.$element = $element;

    var country_popup_wrapper_identifier = "#country-message";
    self.country_popup_wrapper = self.$element.find(
      country_popup_wrapper_identifier
    );
    self.button_stay = self.country_popup_wrapper.find(
      "[data-country-message-stay]"
    );

    // guard: check country popup exists
    if (self.country_popup_wrapper.length == 0) {
      return;
    }
    // guard: check fancybox object exists
    if (typeof $.fancybox != "object") {
      return;
    }

    // get options
    var defaults = {
      current_country_code: "",
      location_api_url: "",
      location_field_name: "",
      popup_messages: {},
    };
    metaOptions = self.country_popup_wrapper.data("country-message-options");
    self.options = $.extend({}, defaults, metaOptions);

    // set country popup cookie identifier
    self.country_popup_cookie_identifier = "country_popup";

    // set fancybox
    self.fancybox = $.fancybox;

    if ($.code.debug) {
      console.log(
        "Init country popup:",
        self.country_popup_wrapper,
        self.options
      );
    }

    // init country popup
    self.init();

    // section loaded reload popup
    $(document).on("shopify:section:load", function (e) {
      if (e.detail.sectionId == "site-country-popup") {
        self.fancybox.close();
        self.init();
      }
    });
  };

  /**
   * Init the country popup plugin
   *
   * @return void
   */
  countryPopup_plugin.prototype.init = function () {
    // scope
    var self = this;

    // if country popup days is set to zero, remove cookie if exists
    if (parseInt(self.options.expires_in_days) == 0) {
      Cookies.remove(self.country_popup_cookie_identifier);
    }

    // Get element
    self.countryPopupCookie = Cookies.get(self.country_popup_cookie_identifier);

    // Render country popup if given
    if (!self.mayRenderCountryPopup()) {
      return false;
    }

    // get country location
    self.getLocation(function () {
      // render the country popup
      self.renderCountryPopup();
    });

    // button close popup
    $(self.button_stay).on("click", function () {
      self.closeCountryPopup();
    });
  };

  /**
   * Check if the country popup may be rendered and that there is a message to show
   *
   * @return boolean
   */
  countryPopup_plugin.prototype.mayRenderCountryPopup = function () {
    // scope
    var self = this;

    // guard: check if popup cookie is set
    if (self.countryPopupCookie) {
      return false;
    }
    // guard: check if there are messages given
    if (self.options.popup_messages.length == 0) {
      return false;
    }

    return true;
  };

  /**
   * Get country location from cookie or GeoAPI
   *
   * @return string country_code
   */
  countryPopup_plugin.prototype.getLocation = function (callback) {
    // scope
    var self = this;

    // get country code from cookie
    self.country_code = Cookies.get(
      self.country_popup_cookie_identifier + "-country_code"
    );

    // if country code is given, return the code
    if (self.country_code) {
      return callback();
    }

    // get country code from api, if done call the callback
    self.getCountryCodeFromAPI().done(function (country_code) {
      self.setCountryCode(country_code);
      return callback();
    });

    return self.country_code;
  };

  /**
   * Get country code from API service
   *
   * @return string country_code
   */
  countryPopup_plugin.prototype.getCountryCodeFromAPI = function () {
    // scope
    var self = this;

    var default_api_url = "//extreme-ip-lookup.com/json/";
    var country_code_api = self.options.location_api_url || default_api_url;
    var country_code_fieldname_identifier =
      self.options.location_field_name || "country_code";

    // guard: get country code api url from options
    if (country_code_api == "") {
      return self;
    }
    // guard: get country code field name
    if (country_code_fieldname_identifier == "") {
      return self;
    }

    // get country coude from api
    return $.getJSON(country_code_api).then(function (response) {
      if (
        typeof response[country_code_fieldname_identifier] != "undefined" &&
        response[country_code_fieldname_identifier] != ""
      ) {
        return response[country_code_fieldname_identifier];
      }
    });
  };

  /**
   * Render the country popup
   *
   * @return string country_code
   */
  countryPopup_plugin.prototype.setCountryCode = function (country_code) {
    // scope
    var self = this;

    // guard: check country code is given
    if (typeof country_code == "undefined" || country_code == "") {
      return "";
    }

    // set the country code
    self.country_code = country_code;

    // create a cookie with the country code
    var inOneHourMinutes = new Date(new Date().getTime() + 60 * 1000);
    Cookies.set(
      self.country_popup_cookie_identifier + "-country_code",
      country_code,
      { expires: inOneHourMinutes }
    );

    return country_code;
  };

  /**
   * Internal function for when calling done from a cookie state
   * @param  callback
   * @return object
   */
  countryPopup_plugin.prototype.done = function (callback) {
    // scope
    var self = this;
    if (typeof calback == "object") {
      callback(self.country_code);
    }
    return self;
  };

  /**
   * Render the country popup
   *
   * @return string country_code
   */
  countryPopup_plugin.prototype.renderCountryPopup = function () {
    // scope
    var self = this;

    // check country code is given
    if (self.country_code == "" || self.options.current_country_code == "") {
      return;
    }
    // guard: if the given country_Code is the same as the shop country code then skip!
    if (self.country_code == self.options.current_country_code) {
      return;
    }

    // get the data by country code if available
    if (typeof self.options.popup_messages[self.country_code] != "undefined") {
      countryData = self.options.popup_messages[self.country_code];

      // if country option does not exists shop ROW
    } else if (typeof self.options.popup_messages["ROW"] != "undefined") {
      countryData = self.options.popup_messages["ROW"];

      // guard: no country data to render
    } else {
      return;
    }

    // populate the wrapper with the country data
    $(self.country_popup_wrapper)
      .find("[data-country-message-title]")
      .text(countryData.country_title || "");
    $(self.country_popup_wrapper)
      .find("[data-country-message-name-title]")
      .text(countryData.country_name || "");
    $(self.country_popup_wrapper)
      .find("[data-country-message-text]")
      .text(countryData.country_body || "");
    $(self.country_popup_wrapper)
      .find("[data-country-message-url]")
      .attr("href", countryData.country_url || "");
    $(self.country_popup_wrapper)
      .find("[data-country-message-label]")
      .text(countryData.country_button || "");
    $(self.country_popup_wrapper)
      .find("[data-country-message-stay]")
      .val(countryData.country_stay || "");

    // open fancybox
    self.fancybox.open(self.country_popup_wrapper, {
      afterClose: function () {
        self.closeCountryPopup();
      },
    });

    // set enable cookie
    Cookies.set(self.country_popup_cookie_identifier, true, {
      expires: self.options.expires_in_days,
    });
  };

  /**
   * Close country popup
   *
   * @return void
   */
  countryPopup_plugin.prototype.closeCountryPopup = function () {
    // scope
    var self = this;

    Cookies.set(self.country_popup_cookie_identifier, false, {
      expires: self.options.expires_in_days,
    });
    self.fancybox.close();
  };

  /**
   * countryPopup plugin
   *
   * @return jQuery objects
   */
  $.fn.countryPopup = function (options) {
    // put args in array
    var args = Array.prototype.slice.call(arguments, 1);

    // initialize the items
    return this.each(function () {
      // store the element the plugin is set on
      var $element = $(this);

      // guard if plugin was already initted
      var instance = $element.data("plugin_" + _pluginName);

      // if plugin was not innited
      if (!instance) {
        // init plugin on element and set guard data on element
        $element.data(
          "plugin_" + _pluginName,
          new countryPopup_plugin($element, options)
        );
      } else {
        // if instance already created call method from plugin
        if (typeof options === "string") {
          instance[options].apply(instance, args);
        }
      }
    });
  };
})(jQuery, document, window);
/****************************************************************
 * CODE swiperLoader
 ****************************************************************/

!(function ($, document, window, undefined) {
  /**
   * Plugin name
   */
  var _pluginName = "swiperLoader";

  /**
   * @param $element Element Wrapping container div
   * @param options Options passed to public functions
   * @return swiperLoader_plugin
   */
  var swiperLoader_plugin = function ($element, options) {
    // scope it
    var self = this;
    self.$element = $element;

    // Set default options, for more options check: https://idangero.us/swiper/api/
    var defaults = {
      loop: false,
      initialSlide: 0, // Index number of initial slide.
      speed: 300, // Duration of transition between slides (in ms)
      direction: "horizontal", // Could be 'horizontal' or 'vertical' (for vertical slider).
      autoHeight: false, // Set to true and slider wrapper will adopt its height to the height of the currently active slide
      roundLengths: true, // Set to true to round values of slides width and height to prevent blurry texts on usual resolution screens (if you have such)
      effect: "slide", // Transition effect. Could be "slide", "fade", "cube", "coverflow" or "flip"
      spaceBetween: 0, // Distance between slides in px.
      slidesPerView: 1, // Number of slides per view (slides visible at the same time on slider's container).
      centeredSlides: false, // 	If true, then active slide will be centered, not always on the left side.
      centerInsufficientSlides: false, // When enabled it center slides if the amount of slides less than `slidesPerView`. Not intended to be used loop mode
      grabCursor: false, // This option may a little improve desktop usability. If true, user will see the "grab" cursor when hover on Swiper
      touchEventsTarget: "wrapper", // Target element to listen touch events on. Can be 'container' (to listen for touch events on swiper-container) or 'wrapper' (to listen for touch events on swiper-wrapper)
      watchOverflow: true, // When enabled Swiper will be disabled and hide navigation buttons on case there are not enough slides for sliding
      shortSwipes: true, // Set to false if you want to disable short swipes
      threshold: 10, // Threshold value in px. If "touch distance" will be lower than this value then swiper will not move
      navigation: {
        nextEl: ".swiper-button-next", //	string / HTMLElement	null	String with CSS selector or HTML element of the element that will work like "next" button after click on it
        prevEl: ".swiper-button-prev", // string / HTMLElement	null	String with CSS selector or HTML element of the element that will work like "prev" button after click on it
        hideOnClick: false, //	Toggle navigation buttons visibility after click on Slider's container
        disabledClass: "swiper-button-disabled", // CSS class name added to navigation button when it becomes disabled
        hiddenClass: "swiper-button-hidden", // CSS class name added to navigation button when it becomes hidden
        nextText:
          '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 116.69 116.69"><defs/><g data-name="Layer 2"><g data-name="Layer 1"><circle cx="58.34" cy="58.34" r="58.34" fill="#fff"/><path fill="#7b7875" d="M33.65 51.52l3.21-3.42 21.48 21.29L80.13 48.1l3.41 3.22-25.2 24.99-24.69-24.79z"/></g></g></svg>',
        prevText:
          '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 116.69 116.69"><defs/><g data-name="Layer 2"><g data-name="Layer 1"><circle cx="58.34" cy="58.34" r="58.34" fill="#fff"/><path fill="#7b7875" d="M33.65 51.52l3.21-3.42 21.48 21.29L80.13 48.1l3.41 3.22-25.2 24.99-24.69-24.79z"/></g></g></svg>',
      },
      pagination: {
        el: ".swiper-pagination",
        type: "bullets", //String with type of pagination. Can be "bullets", "fraction", "progressbar" or "custom"
        bulletElement: "span", //	Defines which HTML tag will be use to represent single pagination bullet. Only for bullets pagination type.
        hideOnClick: false, // Toggle (hide/true) pagination container visibility after click on Slider's container
        clickable: true, //	If true then clicking on pagination button will cause transition to appropriate slide. Only for bullets pagination type
      },
      scrollbar: {
        el: ".swiper-scrollbar",
        hide: true, //	Hide scrollbar automatically after user interaction
        draggable: true, //	Set to true to enable make scrollbar draggable that allows you to control slider position
        snapOnRelease: true, //	Set to false to unsnap slider position to slides when you release scrollbar
        dragSize: "auto", // string/number	Size of scrollbar draggable element in px
        lockClass: "swiper-scrollbar-lock", //	Scrollbar element additional CSS class when it is disabled
        dragClass: "swiper-scrollbar-drag", //	Scrollbar draggable element CSS class
      },
    };

    // get options from element
    var metaOptions = self.$element.data("swiper-options");
    self.options = $.extend({}, defaults, metaOptions, options);

    if ($.code.debug) {
      console.log("Init swiper:", self.$element, self.options);
    }

    self.$element.removeClass("row");
    self.$sliderContainer = self.$element.find(".swiper-container:first");

    // Add elements from options
    if (self.options.scrollbar) {
      self.$sliderContainer.append('<div class="swiper-scrollbar"></div>');
    }
    if (self.options.navigation) {
      self.$sliderContainer.append(
        '<div class="swiper-button-prev">' +
          self.options.navigation.prevText +
          '</div><div class="swiper-button-next">' +
          self.options.navigation.nextText +
          "</div>"
      );
    }
    if (self.options.pagination) {
      self.$sliderContainer.append('<div class="swiper-pagination"></div>');
    }

    // start the swiper
    self.swiperInst = new Swiper(self.$sliderContainer[0], self.options);

    // Custom next navigation (must be [data-swiper] > [data-swiper-nav="next"])
    self.$element.on("click", '[data-swiper-nav="next"]', function () {
      self.swiperInst.slideNext();
    });

    // Custom prev navigation (must be [data-swiper] > [data-swiper-nav="prev"])
    self.$element.on("click", '[data-swiper-nav="prev"]', function () {
      self.swiperInst.slidePrev();
    });

    // Prevent click bubbling on nav elements
    self.$element.on(
      "click",
      ".swiper-button-prev, .swiper-button-next",
      function (event) {
        event.stopPropagation();
      }
    );
  };

  /**
   * Edit slide
   *
   * @return void
   * @access public
   */
  swiperLoader_plugin.prototype.editSlide = function ($slide) {
    var self = this;
    var index = $(self.swiperInst.slides).index($slide);
    self.goToSlide(index - 1);
  };

  /**
   * Go To slide
   *
   * @return void
   * @access public
   */
  swiperLoader_plugin.prototype.goToSlide = function (index, speed) {
    var self = this;

    // If no speed is defined, use the speed from options (speed can be 0)
    if (!speed && speed !== 0) {
      speed = self.options.speed;
    }

    // slide to index
    if (self.options.loop) {
      self.swiperInst.slideToLoop(index, speed);
    } else {
      self.swiperInst.slideTo(index, speed);
    }
  };

  /**
   * swiperLoader plugin
   *
   * @return jQuery objects
   */
  $.fn.swiperLoader = function (options) {
    // put args in array
    var args = Array.prototype.slice.call(arguments, 1);

    // initialize the items
    return this.each(function () {
      // store the element the plugin is set on
      var $element = $(this);

      // guard if plugin was already initted
      var instance = $element.data("plugin_" + _pluginName);

      // if plugin was not innited
      if (!instance) {
        // init plugin on element and set guard data on element
        $element.data(
          "plugin_" + _pluginName,
          new swiperLoader_plugin($element, options)
        );
      } else {
        // if instance already created call method from plugin
        if (typeof options === "string") {
          instance[options].apply(instance, args);
        }
      }
    });
  };
})(jQuery, document, window);

/****************************************************************
 * CODE init
 ****************************************************************/

$.code = $.code || {};

$.code.init = function () {
  // init country popup
  $("body").countryPopup();

  // set debugging flag
  $.code.debug = false;

  if (
    window.location.host.indexOf("localhost") > -1 ||
    window.location.host.indexOf("myshopify") > -1
  ) {
    $.code.debug = true;
  }

  if ($.code.debug) {
    console.log("Init CODE js with debugging");
  }

  // check for localstorage
  $.code.localStorage = $.code.localStorageTest();

  // get window width
  $.code.ww = $(window).width();

  // set if page is in theme editor
  if (typeof Shopify !== "undefined") {
    if (Shopify.designMode) {
      $.code.themeEditor = true;
      $("body").addClass("theme-editor");
      if ($.code.debug) {
        console.log("Theme editor detected");
      }
    }
  }
  /**
   * init plugins
   */

  // Init collection banners
  $("[data-collection-banner-url]").collectionBanner();

  // PDP thumbnails
  if ($("body").hasClass("template-product")) {
    var productImagesSwiper = $(".product-images__slider");
    var productImagesSwiperNav = $(".product-images__slider-nav");
    var swiperOptions = "";
    if (typeof productImagesSwiperNav.data("swiper-options") != "undefined") {
      // Init thumbnail Swiper
      productImagesSwiperNav.swiperLoader();

      // Get the thumbnail Swiper Instance
      var productImagesSwiperNavInstance = productImagesSwiperNav.find(
        ".swiper-container:first"
      )[0].swiper;

      // Set thumbnail instance as thumbs in options for Product image Swiper
      swiperOptions = {
        thumbs: {
          swiper: productImagesSwiperNavInstance,
        },
      };
    }

    // Init Product images Swiper
    productImagesSwiper.swiperLoader(swiperOptions);

    // Custom play button
    $(".product-images__slider").on(
      "click",
      ".product-video",
      function (event) {
        // Check if video is paused
        if ($(this).find("video").get(0).paused) {
          // If playbutton is clicked then trigger play
          if (event.target.className === "play_button") {
            $(this).find("video").trigger("play");
          }

          $(this).addClass("video-playing");
        } else {
          $(this).removeClass("video-playing");
        }
      }
    );
  }

  // Call window resize functions 200ms after window stops being resized
  var timeoutOffset = false;
  $(window).resize(function () {
    if (timeoutOffset !== false) {
      clearTimeout(timeoutOffset);
    }
    timeoutOffset = setTimeout(function () {
      //$.code.onResize();
    }, 200);
  });
};

/**
 * Test for localStorage
 */
$.code.localStorageTest = function () {
  var test = "test";
  try {
    localStorage.setItem(test, test);
    localStorage.removeItem(test);
    return true;
  } catch (e) {
    return false;
  }
};

/**
 * functions to be called after window resizing is finished
 */
$.code.onResize = function () {
  var self = this;

  // get window width
  $.code.ww = $(window).width();
};

/**
 * Initialize CODE JS
 */
$.code.init();

/**
 * shopify Theme editor Events
 */
$(document)
  .on("shopify:section:load", function (e) {
    $("[data-collection-banner-url]").collectionBanner();
  })
  .on("shopify:section:reorder", function (e) {})
  .on("shopify:section:unload", function (e) {})
  .on("shopify:block:select", function (e) {})
  .on("shopify:block:deselect", function (e) {});

// IF COLLECTION URL CONTAINS ?PAGE= THEN REDIRECT TO BLANK COLLECTION URL
if (
  window.location.pathname.includes("collection") &&
  !window.location.pathname.includes("products")
) {
  const urlSearchParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlSearchParams.entries());
  if (params.page) location.href = window.location.pathname;
}

function updateMiniCartQuantity(id, quantity, openCart) {
  let formData = new FormData();
  formData.append("id", id);
  formData.append("quantity", quantity);

  fetch("/cart/change.js", {
    body: formData,
    method: "post",
  })
    .then((response) => response.json())
    .then((response) => {
      if (response.status == "bad_request") {
        alert(response.description);
      } else {
        if (
          response.token != "undefined" &&
          response.token != null &&
          response.token != ""
        ) {
          miniCartRefresh(openCart);
        }
      }
    })
    .catch(function (error) {
      alert(error);
    });
}
function miniCartRefresh(openCart) {
  if (openCart) {
    $("overlay").fadeIn();
  }
  var ajaxUrl = "/cart?view=minicart";
  var currentUrl = window.location.href;

  if (
    currentUrl.indexOf("/en-") != -1 ||
    currentUrl.indexOf("/en/") != -1 ||
    currentUrl.indexOf("-en/") != -1 ||
    currentUrl.endsWith("/en")
  ) {
    ajaxUrl = "https://www.oilily.com/en/cart?view=minicart";
  } else if (
    currentUrl.indexOf("/de-") != -1 ||
    currentUrl.indexOf("/de/") != -1 ||
    currentUrl.indexOf("-de/") != -1 ||
    currentUrl.endsWith("/de")
  ) {
    ajaxUrl = "https://www.oilily.com/de/cart?view=minicart";
  } else {
    ajaxUrl = "https://www.oilily.com/cart?view=minicart";
  }
  $.ajax({
    url: ajaxUrl,
    dataType: "html",
    cache: false,
    success: function (data) {
      $(".my-floating-cart").html("");
      $(".my-floating-cart").html(data);
      if (openCart) {
        $("body").addClass("backdrop_open");
        $("body").addClass("js-minicart-open");
        $(".my-floating-cart").addClass("minicart");
      }
      $.ajax({
        url: "/cart.js",
        dataType: "json",
        cache: false,
        success: function (cart) {
          if (cart.item_count > 0) {
            if ($(".cart-link__count").length > 0) {
              $(".cart-link__count").html(cart.item_count);
            } else {
              $(".cart-link__icon").append(
                '<span class="cart-link__count">' + cart.item_count + "</span>"
              );
            }
          } else {
            $(".cart-link__count").remove();
          }
        },
      });
      $(".minicart-header__close").unbind("click");
      $(".minicart-header__close").on("click", function (e) {
        e.preventDefault();
        $(".my-floating-cart").removeClass("minicart");
        $("overlay").fadeOut();
        $("body").removeClass("js-minicart-open");
        $("body").removeClass("backdrop_open");
      });
      $(".my-floating-cart .pdp_qty a.plus__cart").unbind("click");
      $(".my-floating-cart .pdp_qty a.plus__cart").on("click", function (e) {
        e.preventDefault();
        var itemKey = $(this).parents(".cart__row").attr("data-key");
        if (typeof itemKey != "undefined" && itemKey != null && itemKey != "") {
          var inputValue = $(this)
            .parent(".pdp_qty")
            .find(".quantity-box")
            .val();
          inputValue = parseInt(inputValue) + 1;
          $(this).parent(".pdp_qty").find(".quantity-box").val(inputValue);
          updateMiniCartQuantity(itemKey, inputValue, false);
        }
      });
      $(".my-floating-cart .pdp_qty a.minus__cart").unbind("click");
      $(".my-floating-cart .pdp_qty a.minus__cart").on("click", function (e) {
        e.preventDefault();
        var itemKey = $(this).parents(".cart__row").attr("data-key");
        if (typeof itemKey != "undefined" && itemKey != null && itemKey != "") {
          var inputValue = $(this)
            .parent(".pdp_qty")
            .find(".quantity-box")
            .val();
          inputValue = parseInt(inputValue) - 1;
          $(this).parent(".pdp_qty").find(".quantity-box").val(inputValue);
          updateMiniCartQuantity(itemKey, inputValue, false);
        }
      });
      $(".my-floating-cart a.remove__cart").unbind("click");
      $(".my-floating-cart a.remove__cart").on("click", function (e) {
        e.preventDefault();
        var itemKey = $(this).parents(".cart__row").attr("data-key");
        if (typeof itemKey != "undefined" && itemKey != null && itemKey != "") {
          updateMiniCartQuantity(itemKey, 0, false);
        }
      });
    },
    error: function (XMLHttpRequest) {
      alert(XMLHttpRequest.responseJSON.description);
    },
  });
}
$(".1cart-link1").on("click", function (e) {
  e.preventDefault();
  miniCartRefresh(true);
});
